"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContinuityKeySchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
exports.ContinuityKeySchema = zod_1.z.object({
    type: enums_1.ContinuityKeyTypeSchema,
    value: zod_1.z.string(),
});
//# sourceMappingURL=continuity-key.js.map